///// React Query helper functions

export function idFromUrl(url: string): string {
  // Last part of the url is a number; return it.
  // Used to translate URLs to IDs.
  const parts = url.split("/");
  const filteredParts = parts.filter((part) => !!part); // Remove empty parts
  return filteredParts[filteredParts.length - 1];
}

export const QUERY_OPTIONS = {
  staleTime: 5 * 60 * 1000,
  retry: false as const,
  refetchOnMount: false as const,
  refetchOnWindowsFocus: false as const,
  refetchOnReconnect: true as const,
  refetchIntervalInBackground: true as const,
  refetchInterval: false as const,
};

// Error to throw if status code isn't 2xx
export class FetchError extends Error {
  constructor(public res: Response, message?: string) {
    super(message);
  }
}

// Fetch wrapper that throws an error on bad status
export const fetchWithError = async (path: string) => {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const ISLOCALHOST = window.location.hostname === "localhost";
  if (ISLOCALHOST) path = path.replace("https://api.staging.3di.live", window.location.origin);

  const response = await fetch(path, {
    method: "GET",
    credentials: "include",
    headers,
  });

  if (response.ok) {
    const data = await response.json();
    return data;
  } else {
    throw new FetchError(response, `Received status: ${response.status}`);
  }
};
